// Mock data for the AI Voice Agents module — frontend prototype only.
// All identifiers, transcripts, scores, and integration states are synthetic.

const today = new Date();
const iso = (offsetMin = 0) => new Date(today.getTime() - offsetMin * 60000).toISOString();

export const VOICE_AGENTS = [
  {
    id: 'AI-VA-001', name: 'Sara', initials: 'SR',
    type: 'Early Reminder', useCase: 'Early-stage soft reminders, 0–30 DPD',
    language: 'Arabic', dialect: 'Saudi Najdi',
    voice: 'Saudi Female · Empathetic',
    tone: 'Empathetic', status: 'Active',
    callsToday: 412, successRate: 64.2, complianceScore: 98,
    assignedCampaigns: ['Retail Finance — Early Delinquency', 'Credit Card — PTP Follow-up'],
    owner: 'Noura Al-Dosari', lastUpdated: '2 hours ago',
    color: 'rose',
  },
  {
    id: 'AI-VA-002', name: 'Fahad', initials: 'FH',
    type: 'Payment Arrangement', useCase: 'Negotiates 3/6/12-month installment plans',
    language: 'Arabic', dialect: 'Saudi Najdi',
    voice: 'Saudi Male · Firm but Respectful',
    tone: 'Firm', status: 'Active',
    callsToday: 286, successRate: 58.7, complianceScore: 96,
    assignedCampaigns: ['Auto Loan — 30 DPD', 'SME Portfolio — Soft Reminder'],
    owner: 'Mohammed Al-Otaibi', lastUpdated: 'yesterday',
    color: 'amber',
  },
  {
    id: 'AI-VA-003', name: 'Noura', initials: 'NR',
    type: 'Hardship Intake', useCase: 'Captures hardship details, routes to supervisor',
    language: 'Arabic', dialect: 'Saudi Hijazi',
    voice: 'Saudi Female · Calm',
    tone: 'Empathetic', status: 'Active',
    callsToday: 94, successRate: 71.3, complianceScore: 99,
    assignedCampaigns: ['Retail Finance — Hardship Triage'],
    owner: 'Layla Bin Ali', lastUpdated: '4 hours ago',
    color: 'emerald',
  },
  {
    id: 'AI-VA-004', name: 'Khalid', initials: 'KH',
    type: 'Legal Pre-Escalation', useCase: 'Formal pre-litigation notice + last chance offer',
    language: 'Arabic', dialect: 'Modern Standard Arabic',
    voice: 'Saudi Male · Formal',
    tone: 'Formal', status: 'Pending Approval',
    callsToday: 0, successRate: 0, complianceScore: 100,
    assignedCampaigns: ['Legal Pre-Escalation Queue'],
    owner: 'Sara Al-Qahtani', lastUpdated: '1 hour ago',
    color: 'indigo',
  },
  {
    id: 'AI-VA-005', name: 'Maha', initials: 'MH',
    type: 'Payment Confirmation', useCase: 'Confirms commitment, schedules follow-up',
    language: 'Bilingual', dialect: 'Saudi Najdi · English',
    voice: 'Bilingual Female · Professional',
    tone: 'Professional', status: 'Active',
    callsToday: 178, successRate: 82.4, complianceScore: 97,
    assignedCampaigns: ['Payment Confirmation Batch'],
    owner: 'Fares Sayer', lastUpdated: '30 min ago',
    color: 'sky',
  },
  {
    id: 'AI-VA-006', name: 'Tareq', initials: 'TQ',
    type: 'Dispute Intake', useCase: 'Captures dispute reason + evidence list',
    language: 'Arabic', dialect: 'Saudi Najdi',
    voice: 'Saudi Male · Calm',
    tone: 'Professional', status: 'Draft',
    callsToday: 0, successRate: 0, complianceScore: 100,
    assignedCampaigns: [],
    owner: 'Khalid Al-Harbi', lastUpdated: '6 hours ago',
    color: 'violet',
  },
];

export const AI_CAMPAIGNS = [
  { id: 'CMP-AI-001', name: 'Retail Finance — Early Delinquency', client: 'Saudi Retail Bank', portfolio: 'PRT-2026-014', stage: '0–30 DPD',
    debtors: 1284, balance: 14820500, agent: 'AI-VA-001', team: 'Early Collections — Riyadh',
    channelMix: 'AI Voice 70% · WhatsApp 30%', status: 'Active', successRate: 64.2, complianceScore: 98 },
  { id: 'CMP-AI-002', name: 'Auto Loan — 30 DPD', client: 'Najm Auto Finance', portfolio: 'PRT-2026-015', stage: '30–60 DPD',
    debtors: 642, balance: 27305000, agent: 'AI-VA-002', team: 'Auto Recovery — Jeddah',
    channelMix: 'AI Voice 60% · Human 40%', status: 'Active', successRate: 58.7, complianceScore: 96 },
  { id: 'CMP-AI-003', name: 'Credit Card — PTP Follow-up', client: 'Saudi Retail Bank', portfolio: 'PRT-2026-014', stage: '60–90 DPD',
    debtors: 412, balance: 3120000, agent: 'AI-VA-001', team: 'Card Ops — Riyadh',
    channelMix: 'AI Voice 80% · SMS 20%', status: 'Active', successRate: 49.8, complianceScore: 99 },
  { id: 'CMP-AI-004', name: 'SME Portfolio — Soft Reminder', client: 'Bidaya Home Finance', portfolio: 'PRT-2026-018', stage: '0–30 DPD',
    debtors: 218, balance: 38420000, agent: 'AI-VA-002', team: 'SME Desk',
    channelMix: 'AI Voice 50% · Human 50%', status: 'Paused', successRate: 41.2, complianceScore: 95 },
  { id: 'CMP-AI-005', name: 'Legal Pre-Escalation Queue', client: 'Cross-portfolio', portfolio: 'multi', stage: '120+ DPD',
    debtors: 96, balance: 6420000, agent: 'AI-VA-004', team: 'Pre-Legal Desk',
    channelMix: 'AI Voice 100%', status: 'Pending Approval', successRate: 0, complianceScore: 100 },
  { id: 'CMP-AI-006', name: 'Payment Confirmation Batch', client: 'Cross-portfolio', portfolio: 'multi', stage: 'Any',
    debtors: 3120, balance: 0, agent: 'AI-VA-005', team: 'Confirmation Desk',
    channelMix: 'AI Voice 100%', status: 'Active', successRate: 82.4, complianceScore: 97 },
];

const SAMPLE_DEBTORS = [
  { id: 'DBT-88212', name: 'Tariq N.', phoneMasked: '+9665****210', segment: 'Retail · Riyadh' },
  { id: 'DBT-88207', name: 'Sara F.',  phoneMasked: '+9665****314', segment: 'Card · Jeddah'   },
  { id: 'DBT-88231', name: 'Fahad A.', phoneMasked: '+9665****187', segment: 'Auto · Dammam'   },
  { id: 'DBT-88198', name: 'Reem S.',  phoneMasked: '+9665****042', segment: 'BNPL · Mecca'    },
  { id: 'DBT-88245', name: 'Ahmed B.', phoneMasked: '+9665****599', segment: 'Mortgage · Riyadh' },
];

const OUTCOMES = ['Promise to Pay', 'Plan Created', 'Hardship Captured', 'Dispute Captured', 'No Answer', 'Refused', 'Escalated', 'Wrong Party', 'Paid'];

// Realistic Saudi Arabic transcript fragments per scenario.
const TRANSCRIPT_LIBRARY = {
  ptp: [
    { who: 'agent',  ar: 'السلام عليكم، معك سارة من فريق المتابعة. أتحدّث مع الأستاذ طارق؟' },
    { who: 'debtor', ar: 'وعليكم السلام، نعم أنا.' },
    { who: 'agent',  ar: 'تواصلنا معك بخصوص مبلغ مستحق ومتأخر قدره 4,820 ريال على حسابك.' },
    { who: 'debtor', ar: 'أعرف، أقدر أسدّد نهاية الشهر إن شاء الله.' },
    { who: 'agent',  ar: 'ممتاز. خلني أتأكد: المبلغ 4,820 ريال بتاريخ 28 يونيو، عن طريق سداد. صحيح؟' },
    { who: 'debtor', ar: 'تمام، صحيح.' },
    { who: 'agent',  ar: 'شكراً لتعاونك، راح يوصلك رابط السداد على الواتساب الآن.' },
  ],
  hardship: [
    { who: 'agent',  ar: 'السلام عليكم أستاذ فهد، معك نورة من فريق المتابعة.' },
    { who: 'debtor', ar: 'وعليكم السلام، نورة والله الوضع صعب هالشهر.' },
    { who: 'agent',  ar: 'أتفهم تماماً. تسمح لي أوضح لك خيارات برنامج التيسير وإعادة الجدولة؟' },
    { who: 'debtor', ar: 'إيه، ممكن.' },
    { who: 'agent',  ar: 'بإمكاننا تخفيض الدفعة لمدة 3 شهور مع جدولة الباقي على 12 قسط. أحوّل ملفك للمشرف للموافقة.' },
    { who: 'debtor', ar: 'الله يعطيكم العافية.' },
  ],
  dispute: [
    { who: 'agent',  ar: 'السلام عليكم، معك سارة من فريق المتابعة.' },
    { who: 'debtor', ar: 'وعليكم السلام، أنا معترض على المبلغ، ما هو صحيح.' },
    { who: 'agent',  ar: 'تم تسجيل الاعتراض. ممكن توضح لي السبب باختصار؟' },
    { who: 'debtor', ar: 'الدفعة كانت محولة قبل 10 أيام وما ظهرت في الحساب.' },
    { who: 'agent',  ar: 'تمام، راح أعلق المطالبة 7 أيام عمل وأحوّل الملف للقسم القانوني للمراجعة.' },
  ],
  no_contact: [
    { who: 'agent',  ar: 'السلام عليكم، معك سارة من فريق المتابعة.' },
    { who: 'debtor', ar: 'لا تتصلون عليّ مرة ثانية.' },
    { who: 'agent',  ar: 'تم. تم تسجيل طلب عدم التواصل، ولن نستمر في المكالمة. شكراً لك.' },
  ],
  wrong_party: [
    { who: 'agent',  ar: 'السلام عليكم، أتحدّث مع الأستاذ طارق؟' },
    { who: 'debtor', ar: 'لا، خطأ.' },
    { who: 'agent',  ar: 'آسفة على الإزعاج، شكراً وعفواً.' },
  ],
  pay_now: [
    { who: 'agent',  ar: 'السلام عليكم، معك ماها من فريق التأكيد.' },
    { who: 'debtor', ar: 'وعليكم السلام، أبغى أسدد الحين.' },
    { who: 'agent',  ar: 'ممتاز، راح أرسل لك رابط سداد بالمبلغ 4,820 ريال على الواتساب الآن.' },
  ],
};

export const CALL_SCENARIOS = [
  { id: 'sc-1',  label: 'Cooperative debtor — full payment',   transcript: 'pay_now',     sentiment: 'Positive', outcome: 'Paid',                 ptp: 4820,  date: '2026-06-22' },
  { id: 'sc-2',  label: 'Debtor requests installment plan',     transcript: 'ptp',         sentiment: 'Positive', outcome: 'Plan Created',         ptp: 4820,  date: '2026-06-28' },
  { id: 'sc-3',  label: 'Hardship — needs supervisor approval', transcript: 'hardship',    sentiment: 'Stressed', outcome: 'Hardship Captured',    ptp: 0,     date: null },
  { id: 'sc-4',  label: 'Dispute — held for legal review',      transcript: 'dispute',     sentiment: 'Neutral',  outcome: 'Dispute Captured',     ptp: 0,     date: null },
  { id: 'sc-5',  label: 'Wrong-party answers',                  transcript: 'wrong_party', sentiment: 'Neutral',  outcome: 'Wrong Party',          ptp: 0,     date: null },
  { id: 'sc-6',  label: 'Debtor refuses contact',               transcript: 'no_contact',  sentiment: 'Angry',    outcome: 'Refused · DNC set',    ptp: 0,     date: null },
  { id: 'sc-7',  label: 'Promise to pay — week ahead',          transcript: 'ptp',         sentiment: 'Positive', outcome: 'Promise to Pay',       ptp: 4820,  date: '2026-06-29' },
];

export const AI_CALLS = Array.from({ length: 42 }).map((_, i) => {
  const d = SAMPLE_DEBTORS[i % SAMPLE_DEBTORS.length];
  const a = VOICE_AGENTS[i % 5];
  const s = CALL_SCENARIOS[i % CALL_SCENARIOS.length];
  return {
    callId: `AI-CALL-${28430 + i}`,
    debtorId: d.id, debtorName: d.name, phoneMasked: d.phoneMasked, segment: d.segment,
    campaign: AI_CAMPAIGNS[i % AI_CAMPAIGNS.length].name,
    aiAgent: a.name, aiAgentId: a.id,
    callDateTime: iso(i * 12 + Math.floor(Math.random() * 6)),
    duration: 30 + Math.floor(Math.random() * 180),
    outcome: s.outcome, sentiment: s.sentiment,
    verificationStatus: s.outcome === 'Wrong Party' ? 'Failed' : 'Passed',
    promiseToPayAmount: s.ptp, promiseToPayDate: s.date,
    disputeFlag: s.outcome === 'Dispute Captured',
    hardshipFlag: s.outcome === 'Hardship Captured',
    complianceStatus: i % 11 === 0 ? 'Warning' : 'Passed',
    transcript: TRANSCRIPT_LIBRARY[s.transcript],
    summary: scenarioSummary(s.outcome, d.name),
    nextAction: scenarioNextAction(s.outcome),
    escalation: ['Hardship Captured', 'Dispute Captured'].includes(s.outcome) ? s.outcome : null,
  };
});

function scenarioSummary(outcome, name) {
  switch (outcome) {
    case 'Paid':                return `${name} agreed to pay in full immediately. Payment link sent via WhatsApp; case auto-closes on settlement.`;
    case 'Plan Created':        return `${name} accepted a 3-installment plan over 90 days, first payment 28 Jun. Plan auto-generated and pending debtor SADAD authorisation.`;
    case 'Promise to Pay':      return `${name} promised to pay SAR 4,820 by 29 Jun. SMS confirmation queued; broken-promise watcher armed.`;
    case 'Hardship Captured':   return `${name} disclosed reduced income. Routed to supervisor for hardship program approval; collection paused 7 days.`;
    case 'Dispute Captured':    return `${name} disputed the balance citing an unreflected payment. Legal officer notified; account held 7 business days.`;
    case 'Wrong Party':         return `Number reached a non-debtor. Phone marked for skip-trace review; no debt info disclosed.`;
    default:                    return `${name} declined to engage. Do-not-contact preference recorded; outreach paused indefinitely.`;
  }
}

function scenarioNextAction(outcome) {
  switch (outcome) {
    case 'Paid':                return 'Auto-close case on settlement clearance';
    case 'Plan Created':        return 'Send SADAD authorisation link · arm plan-watcher';
    case 'Promise to Pay':      return 'SMS confirmation + arm broken-promise watcher';
    case 'Hardship Captured':   return 'Route to Supervisor — Hardship Program approval';
    case 'Dispute Captured':    return 'Route to Legal Officer — Dispute review';
    case 'Wrong Party':         return 'Submit to skip-trace queue';
    default:                    return 'Mark DNC + suspend outreach';
  }
}

// Live activity feed for the dashboard.
export const VOICE_ACTIVITY_FEED = [
  { id: 1, kind: 'success', text: 'AI Agent Sara completed 42 calls in Retail Finance — Early Delinquency', when: 'just now' },
  { id: 2, kind: 'warn',    text: 'Dispute detected on CASE-10421 — routed to Legal Review',                 when: '2m ago' },
  { id: 3, kind: 'success', text: 'Promise to Pay captured for SAR 1,250 due 28 Jun',                         when: '4m ago' },
  { id: 4, kind: 'danger',  text: 'Call blocked — contact frequency limit reached for DBT-88207',             when: '6m ago' },
  { id: 5, kind: 'info',    text: 'Customer requested no further calls — DNC preference updated',             when: '8m ago' },
  { id: 6, kind: 'success', text: 'Payment plan accepted: 6 × SAR 803 starting 28 Jun',                       when: '11m ago' },
  { id: 7, kind: 'warn',    text: 'Hardship case captured — supervisor approval queued',                      when: '13m ago' },
  { id: 8, kind: 'success', text: 'Maha confirmed SAR 9,200 commitment with debtor Reem S.',                  when: '15m ago' },
];

// Compliance rules specific to AI voice ops.
export const AI_COMPLIANCE_RULES = [
  { category: 'Contact Rules', items: [
    { id: 'cr-1', label: 'Allowed call hours', value: '09:00 – 21:00 KSA', enabled: true },
    { id: 'cr-2', label: 'Maximum call attempts per debtor', value: '10 / 30 days', enabled: true },
    { id: 'cr-3', label: 'Maximum connected conversations per period', value: '4 / week', enabled: true },
    { id: 'cr-4', label: 'Do-not-contact list enforcement', value: 'Active', enabled: true },
    { id: 'cr-5', label: 'Debtor consent required', value: 'Per Saudi DC Reg.', enabled: true },
    { id: 'cr-6', label: 'Ramadan contact schedule', value: '10:00 – 16:00 + 21:00 – 23:00', enabled: false },
    { id: 'cr-7', label: 'Weekend / holiday schedule', value: '12:00 – 19:00', enabled: true },
  ]},
  { category: 'Identity & Privacy', items: [
    { id: 'ip-1', label: 'Identity verification required before debt disclosure', value: 'Mandatory', enabled: true },
    { id: 'ip-2', label: 'Minimum verification fields', value: 'Last-4 of ID + DOB', enabled: true },
    { id: 'ip-3', label: 'Mask sensitive PII in transcripts', value: 'Active', enabled: true },
    { id: 'ip-4', label: 'Do not disclose debt to third party', value: 'Active', enabled: true },
    { id: 'ip-5', label: 'Call recording disclosure', value: 'Played on every call', enabled: true },
    { id: 'ip-6', label: 'PDPL privacy notice', value: 'On consent', enabled: true },
  ]},
  { category: 'Script Controls', items: [
    { id: 'sc-1', label: 'Approved phrase library only', value: '128 approved', enabled: true },
    { id: 'sc-2', label: 'Banned phrase detection', value: '24 patterns', enabled: true },
    { id: 'sc-3', label: 'Legal escalation phrases require pre-approval', value: 'Active', enabled: true },
    { id: 'sc-4', label: 'Tone monitoring (firmness ceiling)', value: 'Active', enabled: true },
    { id: 'sc-5', label: 'Threat / harassment detection', value: 'Active', enabled: true },
  ]},
  { category: 'Escalation Rules', items: [
    { id: 'es-1', label: 'Dispute mentioned',                value: '→ Legal Officer',     enabled: true },
    { id: 'es-2', label: 'Hardship mentioned',               value: '→ Supervisor',         enabled: true },
    { id: 'es-3', label: 'Vulnerable customer detected',     value: '→ Supervisor',         enabled: true },
    { id: 'es-4', label: 'Legal threat by debtor',           value: '→ Legal Officer',     enabled: true },
    { id: 'es-5', label: 'No-contact request',               value: '→ DNC list',           enabled: true },
    { id: 'es-6', label: 'Angry sentiment',                  value: '→ Human take-over',    enabled: true },
    { id: 'es-7', label: 'Repeated failed verification',     value: '→ Skip trace',         enabled: true },
  ]},
];

export const AI_AUDIT_LOG = [
  { id: 'AL-9241', at: '14:21', actor: 'Noura Al-Dosari', action: 'Updated guardrail',         target: 'Maximum attempts → 10/30d',  severity: 'info' },
  { id: 'AL-9240', at: '13:58', actor: 'Sara Al-Qahtani', action: 'Published agent',           target: 'Khalid — Legal Pre-Escalation', severity: 'warn' },
  { id: 'AL-9239', at: '13:42', actor: 'System',          action: 'Compliance flag created',   target: 'AI-CALL-28447 (window breach)', severity: 'danger' },
  { id: 'AL-9238', at: '12:30', actor: 'Layla Bin Ali',   action: 'Approved script',           target: 'Hardship Intake v3',         severity: 'info' },
  { id: 'AL-9237', at: '11:14', actor: 'System',          action: 'Call blocked',              target: 'Frequency cap — DBT-88207',  severity: 'warn' },
  { id: 'AL-9236', at: '10:02', actor: 'Mohammed Al-Otaibi', action: 'Assigned campaign',      target: 'Auto Loan — 30 DPD → Fahad', severity: 'info' },
];

export const INTEGRATIONS_AI = [
  { id: 'int-tel',    name: 'Telephony / SIP Trunk',   vendor: 'Mock STC Business', status: 'Connected', latency: 41, direction: 'Bidirectional', lastSync: '12s' },
  { id: 'int-iss',    name: 'Issabel Contact Center',  vendor: 'Mock',              status: 'Connected', latency: 58, direction: 'Bidirectional', lastSync: '40s' },
  { id: 'int-wa',     name: 'WhatsApp Business API',   vendor: 'Mock Meta',         status: 'Connected', latency: 78, direction: 'Outbound',      lastSync: '2m'  },
  { id: 'int-sms',    name: 'SMS Gateway',             vendor: 'Mock Unifonic',     status: 'Connected', latency: 36, direction: 'Outbound',      lastSync: '1m'  },
  { id: 'int-email',  name: 'Email Gateway',           vendor: 'Mock SES',          status: 'Connected', latency: 92, direction: 'Outbound',      lastSync: '4m'  },
  { id: 'int-erp',    name: 'ERP / Accounting',        vendor: 'Mock SAP',          status: 'Mock',      latency: 0,  direction: 'Bidirectional', lastSync: '—'   },
  { id: 'int-master', name: 'Debtor Master Data',      vendor: 'Mock Core',         status: 'Connected', latency: 12, direction: 'Inbound',       lastSync: '8s'  },
  { id: 'int-sadad',  name: 'SADAD Payment Gateway',   vendor: 'Mock SADAD',        status: 'Mock',      latency: 0,  direction: 'Outbound',      lastSync: '—'   },
  { id: 'int-naf',    name: 'Nafath Verification',     vendor: 'Mock Nafath',       status: 'Mock',      latency: 0,  direction: 'Inbound',       lastSync: '—'   },
  { id: 'int-simah',  name: 'SIMAH Credit Bureau',     vendor: 'Mock SIMAH',        status: 'Mock',      latency: 0,  direction: 'Inbound',       lastSync: '—'   },
  { id: 'int-legal',  name: 'Legal Case Management',   vendor: 'Mock Najiz',        status: 'Mock',      latency: 0,  direction: 'Outbound',      lastSync: '—'   },
  { id: 'int-dwh',    name: 'Data Warehouse',          vendor: 'Mock Snowflake',    status: 'Connected', latency: 64, direction: 'Outbound',      lastSync: '6m'  },
  { id: 'int-stt',    name: 'Speech-to-Text Provider', vendor: 'Mock Whisper',      status: 'Connected', latency: 22, direction: 'Inbound',       lastSync: '4s'  },
  { id: 'int-tts',    name: 'Text-to-Speech Provider', vendor: 'Mock ElevenLabs',   status: 'Connected', latency: 31, direction: 'Outbound',      lastSync: '6s'  },
  { id: 'int-llm',    name: 'LLM Provider',            vendor: 'Mock Anthropic',    status: 'Connected', latency: 92, direction: 'Bidirectional', lastSync: '11s' },
  { id: 'int-audit',  name: 'Audit Log Export',        vendor: 'Mock S3',           status: 'Connected', latency: 18, direction: 'Outbound',      lastSync: '1m'  },
];

export const VOICE_PROFILES_LIB = [
  { id: 'vp-1', name: 'Saudi Female — Empathetic',    sample: 'Sara',   tone: 'Empathetic',    approvedBy: 'Compliance', version: 'v3.1', usage: 12840, score: 94 },
  { id: 'vp-2', name: 'Saudi Male — Formal',          sample: 'Khalid', tone: 'Formal',        approvedBy: 'Compliance', version: 'v2.4', usage: 4120,  score: 91 },
  { id: 'vp-3', name: 'Saudi Female — Calm Reminder', sample: 'Noura',  tone: 'Calm',          approvedBy: 'Compliance', version: 'v3.0', usage: 6890,  score: 96 },
  { id: 'vp-4', name: 'Saudi Male — Firm Respectful', sample: 'Fahad',  tone: 'Firm',          approvedBy: 'Compliance', version: 'v2.9', usage: 9180,  score: 89 },
  { id: 'vp-5', name: 'Bilingual Arabic / English',   sample: 'Maha',   tone: 'Professional',  approvedBy: 'Compliance', version: 'v1.4', usage: 2840,  score: 92 },
];

export const SCRIPT_TEMPLATES = [
  { id: 'st-1', name: 'Early Reminder',             language: 'AR-SA', tone: 'Empathetic', approvedBy: 'Compliance', version: 'v4.1', lastUpdated: '3d ago',  compliance: 'Passed', usage: 14820, score: 92 },
  { id: 'st-2', name: 'Payment Plan Offer',         language: 'AR-SA', tone: 'Firm',       approvedBy: 'Compliance', version: 'v3.2', lastUpdated: '6d ago',  compliance: 'Passed', usage: 9620,  score: 88 },
  { id: 'st-3', name: 'Promise-to-Pay Confirmation',language: 'AR-SA', tone: 'Professional', approvedBy: 'Compliance', version: 'v2.7', lastUpdated: '2d ago', compliance: 'Passed', usage: 11200, score: 95 },
  { id: 'st-4', name: 'Hardship Intake',             language: 'AR-SA', tone: 'Empathetic', approvedBy: 'Compliance', version: 'v3.0', lastUpdated: '9d ago',  compliance: 'Passed', usage: 4120,  score: 96 },
  { id: 'st-5', name: 'Dispute Intake',              language: 'AR-SA', tone: 'Calm',       approvedBy: 'Legal',      version: 'v2.1', lastUpdated: '1w ago',  compliance: 'Passed', usage: 1840,  score: 90 },
  { id: 'st-6', name: 'Wrong Party Answer',          language: 'AR-SA', tone: 'Calm',       approvedBy: 'Compliance', version: 'v1.2', lastUpdated: '2w ago',  compliance: 'Passed', usage: 6210,  score: 93 },
  { id: 'st-7', name: 'No-Contact Request',          language: 'AR-SA', tone: 'Formal',     approvedBy: 'Compliance', version: 'v1.4', lastUpdated: '4d ago',  compliance: 'Passed', usage: 980,   score: 99 },
  { id: 'st-8', name: 'Legal Pre-Escalation',       language: 'AR-MSA', tone: 'Formal',    approvedBy: 'Legal',      version: 'v1.0', lastUpdated: '1d ago',  compliance: 'Review', usage: 0,     score: 0  },
  { id: 'st-9', name: 'Payment Link Follow-Up',     language: 'AR-SA', tone: 'Professional', approvedBy: 'Compliance', version: 'v2.0', lastUpdated: '3d ago', compliance: 'Passed', usage: 8420,  score: 97 },
];

// Sub-nav definition shared by every voice-agents page.
export const VOICE_NAV = [
  { to: '/app/voice-agents',                   label: 'Dashboard',              end: true },
  { to: '/app/voice-agents/library',           label: 'Agent Library' },
  { to: '/app/voice-agents/create',            label: 'Create Agent' },
  { to: '/app/voice-agents/designer',          label: 'Conversation Designer' },
  { to: '/app/voice-agents/campaigns',         label: 'Campaigns' },
  { to: '/app/voice-agents/simulator',         label: 'Test Simulator' },
  { to: '/app/voice-agents/review',            label: 'Call Review' },
  { to: '/app/voice-agents/analytics',         label: 'Analytics' },
  { to: '/app/voice-agents/compliance',        label: 'Compliance' },
  { to: '/app/voice-agents/voices',            label: 'Voice & Scripts' },
  { to: '/app/voice-agents/integrations',      label: 'Integrations' },
];
